<template>
  <div class="content">
    <div v-loading="loading" class="bodycontent">
      <el-form
        ref="formData"
        :model="formData"
        label-width="180px"
        size="small"
      >
        <el-form-item v-if="LM" label="异业联盟活动">
          <el-radio-group v-model="resource">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="IsShow !== 2">
          <el-form-item v-if="IsShow !== 1" label="等级名称">
            <el-input v-model="formData.name" class="input_box"></el-input>
          </el-form-item>
          <el-form-item v-if="IsShow !== 1" label="等级">
            <el-input-number
              v-model="formData.grade"
              :controls="false"
              class="input_box_small"
            ></el-input-number>
          </el-form-item>
          <!-- 改动 统一折扣改为细分统一、分类别、分油品、享折扣、每升优惠 -->
          <el-form-item label="优惠时间">
            <el-radio-group v-model="timeType">
              <el-radio :label="0">长期有效</el-radio>
              <el-radio :label="1">固定时间段</el-radio>
              <el-radio :label="2">按周期重复</el-radio>
            </el-radio-group>
            <div v-if="timeType == 1">
              <el-date-picker
                v-model="dateValue"
                :default-time="['00:00:00', '23:59:59']"
                end-placeholder="结束日期"
                range-separator="至"
                size="small"
                start-placeholder="开始日期"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </div>
            <div v-if="timeType == 2">
              <el-radio-group v-model="periodType">
                <el-radio class="dblock" label="0">
                  <span class="radio_name">每天</span>
                  <el-time-picker
                    v-model="dayTimeValue[0]"
                    :disabled="periodType != '0'"
                    class="time_picker_box"
                    format="HH:mm:ss"
                    size="small"
                    style="width:130px"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                  至
                  <el-time-picker
                    v-model="dayTimeValue[1]"
                    :disabled="periodType != '0'"
                    class="time_picker_box"
                    format="HH:mm:ss"
                    size="small"
                    style="width:130px"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                </el-radio>
                <el-radio class="dblock" label="1">
                  <span class="radio_name">每月</span>
                  <el-select
                    v-model="monthDayValue"
                    :disabled="periodType != '1'"
                    collapse-tags
                    multiple
                    placeholder="请选择"
                    size="small"
                    style="width:120px"
                  >
                    <el-option
                      v-for="item in monthOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  日
                  <el-time-picker
                    v-model="monthTimeValue[0]"
                    :disabled="periodType != '1'"
                    class="time_picker_box"
                    format="HH:mm:ss"
                    size="small"
                    style="width:130px"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                  至
                  <el-time-picker
                    v-model="monthTimeValue[1]"
                    :disabled="periodType != '1'"
                    class="time_picker_box"
                    format="HH:mm:ss"
                    size="small"
                    style="width:130px"
                    value-format="HH:mm:ss"
                  ></el-time-picker>
                </el-radio>
                <el-radio class="dblock" label="2">
                  <span class="radio_name">每周</span>
                  <!-- 7.1 按周优惠方式 -->
                  <span style="margin-left:20px">
                    <el-radio-group
                      v-model="week_unify"
                      :disabled="periodType != '2'"
                    >
                      <el-radio label="1">统一优惠</el-radio>
                      <el-radio label="0">自定义每天</el-radio>
                    </el-radio-group>
                  </span>
                  <div
                    v-for="(item, idx) in weekDayValue"
                    :key="idx"
                    class="week_item"
                  >
                    <div
                      v-for="(rule, i) in item.rule"
                      :key="i"
                      class="week_item_timeItem"
                    >
                      <div class="week_item_label">
                        <span v-if="i == 0">{{ item.name }}</span>
                      </div>
                      <el-time-picker
                        v-model="rule.stime"
                        :disabled="periodType != '2'"
                        class="time_picker_box"
                        format="HH:mm:ss"
                        size="small"
                        style="width:130px"
                        value-format="HH:mm:ss"
                      ></el-time-picker>
                      至
                      <el-time-picker
                        v-model="rule.etime"
                        :disabled="periodType != '2'"
                        class="time_picker_box"
                        format="HH:mm:ss"
                        size="small"
                        style="width:130px"
                        value-format="HH:mm:ss"
                      ></el-time-picker>
                      <span>
                        <el-popover
                          v-if="week_unify == '0'"
                          placement="right"
                          popper-class="popverClass"
                          trigger="click"
                          width="640"
                        >
                          <el-radio-group
                            v-model="rule.full_reduction"
                            style="margin-bottom:15px"
                          >
                            <el-radio :label="0">无限制</el-radio>
                            <el-radio :label="1">区间满减</el-radio>
                            <el-radio :label="2">每满减</el-radio>
                          </el-radio-group>
                          <div v-if="rule.full_reduction == 1">
                            <div
                              v-for="(dItem, dIndex) in rule.discountList"
                              :key="dIndex"
                              style="margin-bottom:15px"
                            >
                              <span style="margin-right:15px">
                                满
                                <el-input
                                  v-model="dItem.num"
                                  class="input_box_short"
                                ></el-input>
                                元
                              </span>
                              <el-radio-group v-model="dItem.discount_type">
                                <el-radio :label="0">统一优惠</el-radio>
                                <el-radio :label="1">按类别优惠</el-radio>
                                <el-radio :label="2">按油品优惠</el-radio>
                              </el-radio-group>
                              <el-button
                                style="margin-left:20px"
                                type="danger"
                                @click="delLimitItem2(idx, i, dIndex)"
                                >删除满减区间</el-button
                              >
                              <div v-if="dItem.discount_type == 0">
                                <el-radio-group
                                  v-model="
                                    dItem.discount.unified_offer_value.type
                                  "
                                >
                                  <el-radio :label="0" class="dblock">
                                    享受折扣
                                    <el-input
                                      v-model="
                                        dItem.discount.unified_offer_value
                                          .discount
                                      "
                                      class="input_box_mini numberInputStyle"
                                      size="mini"
                                      type="number"
                                    >
                                    </el-input>
                                    折
                                  </el-radio>
                                  <el-radio :label="1" class="dblock">
                                    每升优惠
                                    <el-input
                                      v-model="
                                        dItem.discount.unified_offer_value.money
                                      "
                                      class="input_box_mini"
                                      size="mini"
                                    >
                                    </el-input>
                                    元
                                  </el-radio>
                                  <el-radio :label="2" class="dblock">
                                    直减
                                    <el-input
                                      v-model="
                                        dItem.discount.unified_offer_value
                                          .dec_money
                                      "
                                      class="input_box_mini"
                                      size="mini"
                                    >
                                    </el-input>
                                    元
                                  </el-radio>
                                </el-radio-group>
                              </div>
                              <div v-if="dItem.discount_type == 1">
                                <div
                                  v-for="(n, index) in dItem.discount
                                    .cate_offer_value"
                                  :key="index"
                                  class="type_item"
                                >
                                  <div class="type_name">
                                    <el-select
                                      v-model="n.id"
                                      placeholder="选择类别"
                                    >
                                      <el-option
                                        v-for="type in type_options"
                                        :key="type.id"
                                        :label="type.name"
                                        :value="type.id"
                                      ></el-option>
                                    </el-select>
                                  </div>
                                  <div class="type_value">
                                    <el-radio-group v-model="n.type">
                                      <el-radio :label="0" class="dblock">
                                        享受折扣
                                        <el-input
                                          v-model="n.discount"
                                          class="input_box_mini numberInputStyle"
                                          size="mini"
                                          type="number"
                                          :max="9"
                                          :min="1"
                                        >
                                        </el-input>
                                        折
                                      </el-radio>
                                      <el-radio :label="1" class="dblock">
                                        每升优惠
                                        <el-input
                                          v-model="n.money"
                                          class="input_box_mini"
                                          size="mini"
                                        >
                                        </el-input>
                                        元
                                      </el-radio>
                                      <el-radio :label="2" class="dblock">
                                        直减
                                        <el-input
                                          v-model="n.dec_money"
                                          class="input_box_mini"
                                          size="mini"
                                        >
                                        </el-input>
                                        元
                                      </el-radio>
                                    </el-radio-group>
                                  </div>
                                  <div class="type_del">
                                    <el-button
                                      icon="el-icon-close"
                                      size="mini"
                                      type="danger"
                                      @click="
                                        delTypeItem3(index, 1, idx, i, dIndex)
                                      "
                                    ></el-button>
                                  </div>
                                </div>
                                <div class="add_button">
                                  <el-button
                                    size="small"
                                    type="primary"
                                    @click="addTypeItem3(idx, 1, i, dIndex)"
                                    >增加规则</el-button
                                  >
                                </div>
                              </div>
                              <div v-if="dItem.discount_type == 2">
                                <div
                                  v-for="(n, index) in dItem.discount
                                    .goods_offer_value"
                                  :key="index"
                                  class="type_item"
                                >
                                  <div class="type_name">
                                    <el-select
                                      v-model="n.id"
                                      placeholder="选择油品"
                                    >
                                      <el-option
                                        v-for="type in oils_options"
                                        :key="type.id"
                                        :label="type.name"
                                        :value="type.id"
                                      ></el-option>
                                    </el-select>
                                  </div>
                                  <div class="type_value">
                                    <el-radio-group v-model="n.type">
                                      <el-radio :label="0" class="dblock">
                                        享受折扣
                                        <el-input
                                          v-model="n.discount"
                                          class="input_box_mini numberInputStyle"
                                          size="mini"
                                          type="number"
                                          :max="9"
                                          :min="1"
                                        >
                                        </el-input>
                                        折
                                      </el-radio>
                                      <el-radio :label="1" class="dblock">
                                        每升优惠
                                        <el-input
                                          v-model="n.money"
                                          class="input_box_mini"
                                          size="mini"
                                        >
                                        </el-input>
                                        元
                                      </el-radio>
                                      <el-radio :label="2" class="dblock">
                                        直减
                                        <el-input
                                          v-model="n.dec_money"
                                          class="input_box_mini"
                                          size="mini"
                                        >
                                        </el-input>
                                        元
                                      </el-radio>
                                    </el-radio-group>
                                  </div>
                                  <div class="type_del">
                                    <el-button
                                      icon="el-icon-close"
                                      size="mini"
                                      type="danger"
                                      @click="
                                        delTypeItem3(index, 2, idx, i, dIndex)
                                      "
                                    ></el-button>
                                  </div>
                                </div>
                                <div class="add_button">
                                  <el-button
                                    size="small"
                                    type="primary"
                                    @click="addTypeItem3(idx, 2, i, dIndex)"
                                    >增加规则</el-button
                                  >
                                </div>
                              </div>
                            </div>
                            <el-button
                              icon="el-icon-plus"
                              @click="addLimitItem2(idx, i)"
                              >增加满减区间</el-button
                            >
                          </div>
                          <div v-else>
                            <span
                              v-if="rule.full_reduction == 2"
                              style="margin-right:20px"
                            >
                              每满
                              <el-input
                                v-model="rule.every_money"
                                class="input_box_mini"
                                size="mini"
                              ></el-input>
                              元
                            </span>
                            <el-radio-group v-model="rule.discount_type">
                              <el-radio :label="0">统一优惠</el-radio>
                              <el-radio :label="1">按类别优惠</el-radio>
                              <el-radio :label="2">按油品优惠</el-radio>
                            </el-radio-group>
                            <div v-if="rule.discount_type == 0">
                              <el-radio-group
                                v-model="rule.discount.unified_offer_value.type"
                              >
                                <el-radio :label="0" class="dblock">
                                  享受折扣
                                  <el-input
                                    v-model="
                                      rule.discount.unified_offer_value.discount
                                    "
                                    class="input_box_mini numberInputStyle"
                                    size="mini"
                                    type="number"
                                    :max="9"
                                    :min="1"
                                  >
                                  </el-input>
                                  折
                                </el-radio>
                                <el-radio :label="1" class="dblock">
                                  每升优惠
                                  <el-input
                                    v-model="
                                      rule.discount.unified_offer_value.money
                                    "
                                    class="input_box_mini"
                                    size="mini"
                                  >
                                  </el-input>
                                  元
                                </el-radio>
                                <el-radio
                                  v-if="rule.full_reduction == 2"
                                  :label="2"
                                  class="dblock"
                                >
                                  直减
                                  <el-input
                                    v-model="
                                      rule.discount.unified_offer_value
                                        .dec_money
                                    "
                                    class="input_box_mini"
                                    size="mini"
                                  >
                                  </el-input>
                                  元
                                </el-radio>
                              </el-radio-group>
                            </div>
                            <div v-if="rule.discount_type == 1">
                              <div
                                v-for="(n, index) in rule.discount
                                  .cate_offer_value"
                                :key="index"
                                class="type_item"
                              >
                                <div class="type_name">
                                  <el-select
                                    v-model="n.id"
                                    placeholder="选择类别"
                                  >
                                    <el-option
                                      v-for="type in type_options"
                                      :key="type.id"
                                      :label="type.name"
                                      :value="type.id"
                                    ></el-option>
                                  </el-select>
                                </div>
                                <div class="type_value">
                                  <el-radio-group v-model="n.type">
                                    <el-radio :label="0" class="dblock">
                                      享受折扣
                                      <el-input
                                        v-model="n.discount"
                                        class="input_box_mini numberInputStyle"
                                        size="mini"
                                        type="number"
                                        :max="9"
                                        :min="1"
                                      >
                                      </el-input>
                                      折
                                    </el-radio>
                                    <el-radio :label="1" class="dblock">
                                      每升优惠
                                      <el-input
                                        v-model="n.money"
                                        class="input_box_mini"
                                        size="mini"
                                      >
                                      </el-input>
                                      元
                                    </el-radio>
                                    <el-radio
                                      v-if="rule.full_reduction == 2"
                                      :label="2"
                                      class="dblock"
                                    >
                                      直减
                                      <el-input
                                        v-model="n.dec_money"
                                        class="input_box_mini"
                                        size="mini"
                                      >
                                      </el-input>
                                      元
                                    </el-radio>
                                  </el-radio-group>
                                </div>
                                <div class="type_del">
                                  <el-button
                                    icon="el-icon-close"
                                    size="mini"
                                    type="danger"
                                    @click="delTypeItem2(index, 1, idx, i)"
                                  ></el-button>
                                </div>
                              </div>
                              <div class="add_button">
                                <el-button
                                  size="small"
                                  type="primary"
                                  @click="addTypeItem2(idx, 1, i)"
                                  >增加规则</el-button
                                >
                              </div>
                            </div>
                            <div v-if="rule.discount_type == 2">
                              <div
                                v-for="(n, index) in rule.discount
                                  .goods_offer_value"
                                :key="index"
                                class="type_item"
                              >
                                <div class="type_name">
                                  <el-select
                                    v-model="n.id"
                                    placeholder="选择油品"
                                  >
                                    <el-option
                                      v-for="type in oils_options"
                                      :key="type.id"
                                      :label="type.name"
                                      :value="type.id"
                                    ></el-option>
                                  </el-select>
                                </div>
                                <div class="type_value">
                                  <el-radio-group v-model="n.type">
                                    <el-radio :label="0" class="dblock">
                                      享受折扣
                                      <el-input
                                        v-model="n.discount"
                                        class="input_box_mini numberInputStyle"
                                        size="mini"
                                        type="number"
                                        :max="9"
                                        :min="1"
                                      >
                                      </el-input>
                                      折
                                    </el-radio>
                                    <el-radio :label="1" class="dblock">
                                      每升优惠
                                      <el-input
                                        v-model="n.money"
                                        class="input_box_mini"
                                        size="mini"
                                      >
                                      </el-input>
                                      元
                                    </el-radio>
                                    <el-radio
                                      v-if="rule.full_reduction == 2"
                                      :label="2"
                                      class="dblock"
                                    >
                                      直减
                                      <el-input
                                        v-model="n.dec_money"
                                        class="input_box_mini"
                                        size="mini"
                                      >
                                      </el-input>
                                      元
                                    </el-radio>
                                  </el-radio-group>
                                </div>
                                <div class="type_del">
                                  <el-button
                                    icon="el-icon-close"
                                    size="mini"
                                    type="danger"
                                    @click="delTypeItem2(index, 2, idx, i)"
                                  ></el-button>
                                </div>
                              </div>
                              <div class="add_button">
                                <el-button
                                  size="small"
                                  type="primary"
                                  @click="addTypeItem2(idx, 2, i)"
                                  >增加规则</el-button
                                >
                              </div>
                            </div>
                          </div>
                          <el-button
                            slot="reference"
                            :disabled="periodType != '2'"
                            size="small"
                            type="primary"
                            >设置优惠</el-button
                          >
                        </el-popover>
                      </span>
                      <span>
                        <el-button
                          v-if="i != 0"
                          size="small"
                          type="danger"
                          @click="delWeekItem(idx, i)"
                          >删除</el-button
                        >
                      </span>
                    </div>

                    <div style="padding-left:50px">
                      <el-button type="text" @click="addWeekItemTime(idx)"
                        >添加时间段
                      </el-button>
                    </div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <el-form-item
          v-if="week_unify != '0' || periodType != '2' || timeType != '2'"
          label="优惠内容"
        >
          <!-- <el-input-number v-model="formData.discount" class="input_box_small" :controls="false"></el-input-number> -->
          <!-- 改动 增加优惠条件 满多少才享受优惠 且分金额区间设置优惠 s0706 -->
          <div>
            <span style="margin-right:15px">是否开启优惠限制</span>
            <el-radio-group v-model="limit">
              <el-radio :label="0">无限制</el-radio>
              <el-radio :label="1">区间满减</el-radio>
              <el-radio :label="2">每满减</el-radio>
            </el-radio-group>
          </div>
          <div v-if="limit == 1">
            <div
              v-for="(dItem, dIndex) in discountList"
              :key="dIndex"
              style="margin-bottom:20px"
            >
              <span style="margin-right:15px"
                >满
                <el-input
                  v-model="dItem.num"
                  class="input_box_short"
                ></el-input>
                元
              </span>
              <el-radio-group v-model="dItem.discount_type">
                <el-radio :label="0">统一优惠</el-radio>
                <el-radio :label="1">按类别优惠</el-radio>
                <el-radio :label="2">按油品优惠</el-radio>
              </el-radio-group>
              <el-button
                style="margin-left:20px"
                type="danger"
                @click="delLimitItem(dIndex)"
                >删除满减区间
              </el-button>
              <div v-if="dItem.discount_type == 0">
                <el-radio-group v-model="dItem.unified_offer_value.type">
                  <el-radio :label="0" class="dblock">
                    享受折扣
                    <el-input
                      v-model="dItem.unified_offer_value.discount"
                      class="input_box_mini numberInputStyle"
                      size="mini"
                      type="number"
                      :max="9"
                      :min="1"
                    >
                    </el-input>
                    折
                  </el-radio>
                  <el-radio :label="1" class="dblock">
                    每升优惠
                    <el-input
                      v-model="dItem.unified_offer_value.money"
                      class="input_box_mini"
                      size="mini"
                    >
                    </el-input>
                    元
                  </el-radio>
                  <el-radio :label="2" class="dblock">
                    直减
                    <el-input
                      v-model="dItem.unified_offer_value.dec_money"
                      class="input_box_mini"
                      size="mini"
                    >
                    </el-input>
                    元
                  </el-radio>
                </el-radio-group>
              </div>
              <div v-if="dItem.discount_type == 1">
                <div
                  v-for="(item, index) in dItem.type_discount_list"
                  :key="index"
                  class="type_item"
                >
                  <div class="type_name">
                    <el-select v-model="item.id" placeholder="选择类别">
                      <el-option
                        v-for="type in type_options"
                        :key="type.id"
                        :label="type.name"
                        :value="type.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="type_value">
                    <el-radio-group v-model="item.type">
                      <el-radio :label="0" class="dblock">
                        享受折扣
                        <el-input
                          v-model="item.discount"
                          class="input_box_mini numberInputStyle"
                          size="mini"
                          type="number"
                          :max="9"
                          :min="1"
                        >
                        </el-input>
                        折
                      </el-radio>
                      <el-radio :label="1" class="dblock">
                        每升优惠
                        <el-input
                          v-model="item.money"
                          class="input_box_mini"
                          size="mini"
                        >
                        </el-input>
                        元
                      </el-radio>
                      <el-radio :label="2" class="dblock">
                        直减
                        <el-input
                          v-model="item.dec_money"
                          class="input_box_mini"
                          size="mini"
                        >
                        </el-input>
                        元
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div class="type_del">
                    <el-button
                      icon="el-icon-close"
                      size="mini"
                      type="danger"
                      @click="delTypeItemD(index, 1, dIndex)"
                    ></el-button>
                  </div>
                </div>
                <div class="add_button">
                  <el-button
                    size="small"
                    type="primary"
                    @click="addTypeItemD(1, dIndex)"
                    >增加规则
                  </el-button>
                </div>
              </div>
              <div v-if="dItem.discount_type == 2">
                <div
                  v-for="(item, index) in dItem.oils_discount_list"
                  :key="index"
                  class="type_item"
                >
                  <div class="type_name">
                    <el-select v-model="item.id" placeholder="选择油品">
                      <el-option
                        v-for="type in oils_options"
                        :key="type.id"
                        :disabled="type.disable"
                        :label="type.name"
                        :value="type.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="type_value">
                    <el-radio-group v-model="item.type">
                      <el-radio :label="0" class="dblock">
                        享受折扣
                        <el-input
                          v-model="item.discount"
                          class="input_box_mini numberInputStyle"
                          size="mini"
                          type="number"
                          :max="9"
                          :min="1"
                        >
                        </el-input>
                        折
                      </el-radio>
                      <el-radio :label="1" class="dblock">
                        每升优惠
                        <el-input
                          v-model="item.money"
                          class="input_box_mini"
                          size="mini"
                        >
                        </el-input>
                        元
                      </el-radio>
                      <el-radio :label="2" class="dblock">
                        直减
                        <el-input
                          v-model="item.dec_money"
                          class="input_box_mini"
                          size="mini"
                        >
                        </el-input>
                        元
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div class="type_del">
                    <el-button
                      icon="el-icon-close"
                      size="mini"
                      type="danger"
                      @click="delTypeItemD(index, 2, dIndex)"
                    ></el-button>
                  </div>
                </div>
                <div class="add_button">
                  <el-button
                    size="small"
                    type="primary"
                    @click="addTypeItemD(2, dIndex)"
                    >增加规则
                  </el-button>
                </div>
              </div>
            </div>
            <el-button icon="el-icon-plus" @click="addLimitItem()"
              >增加满减区间
            </el-button>
          </div>
          <div v-else>
            <span v-if="limit == 2" style="margin-right:20px">
              每满
              <el-input
                v-model="everyMoney"
                class="input_box_mini"
                size="mini"
              ></el-input>
              元
            </span>
            <el-radio-group
              v-model="discount_type"
              @change="changeDiscountType"
            >
              <el-radio :label="0">统一优惠</el-radio>
              <el-radio :label="1">按类别优惠</el-radio>
              <el-radio :label="2">按油品优惠</el-radio>
            </el-radio-group>
            <div v-if="discount_type == 0">
              <el-radio-group v-model="unified_type">
                <el-radio :label="0" class="dblock">
                  享受折扣
                  <el-input
                    v-model="unified_type_value.discount"
                    class="input_box_mini numberInputStyle"
                    size="mini"
                    type="number"
                    @focus="inputFocus(0, 0)"
                  >
                  </el-input>
                  折
                </el-radio>
                <el-radio :label="1" class="dblock">
                  每升优惠
                  <el-input
                    v-model="unified_type_value.money"
                    class="input_box_mini"
                    size="mini"
                    @focus="inputFocus(0, 1)"
                  >
                  </el-input>
                  元
                </el-radio>
                <el-radio v-if="limit == 2" :label="2" class="dblock">
                  直减
                  <el-input
                    v-model="unified_type_value.dec_money"
                    class="input_box_mini"
                    size="mini"
                    @focus="inputFocus(0, 2)"
                  >
                  </el-input>
                  元
                </el-radio>
              </el-radio-group>
            </div>
            <div v-if="discount_type == 1">
              <div
                v-for="(item, index) in type_discount_list"
                :key="index"
                class="type_item"
              >
                <div class="type_name">
                  <el-select
                    v-model="item.id"
                    placeholder="选择类别"
                    @change="resetOptions(1)"
                  >
                    <el-option
                      v-for="type in type_options"
                      :key="type.id"
                      :disabled="type.disable"
                      :label="type.name"
                      :value="type.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="type_value">
                  <el-radio-group v-model="item.type">
                    <el-radio :label="0" class="dblock">
                      享受折扣
                      <el-input
                        v-model="item.discount"
                        class="input_box_mini numberInputStyle"
                        size="mini"
                        type="number"
                        :max="9"
                        :min="1"
                        @focus="inputFocus(1, index, 0)"
                      >
                      </el-input>
                      折
                    </el-radio>
                    <el-radio :label="1" class="dblock">
                      每升优惠
                      <el-input
                        v-model="item.money"
                        class="input_box_mini"
                        size="mini"
                        @focus="inputFocus(1, index, 1)"
                      >
                      </el-input>
                      元
                    </el-radio>
                    <el-radio v-if="limit == 2" :label="2" class="dblock">
                      直减
                      <el-input
                        v-model="item.dec_money"
                        class="input_box_mini"
                        size="mini"
                        @focus="inputFocus(1, index, 2)"
                      >
                      </el-input>
                      元
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="type_del">
                  <el-button
                    icon="el-icon-close"
                    size="mini"
                    type="danger"
                    @click="delTypeItem(index, 1)"
                  ></el-button>
                </div>
              </div>
              <div class="add_button">
                <el-button size="small" type="primary" @click="addTypeItem(1)"
                  >增加规则
                </el-button>
              </div>
            </div>
            <div v-if="discount_type == 2">
              <div
                v-for="(item, index) in oils_discount_list"
                :key="index"
                class="type_item"
              >
                <div class="type_name">
                  <el-select
                    v-model="item.id"
                    placeholder="选择油品"
                    @change="resetOptions(2)"
                  >
                    <el-option
                      v-for="type in oils_options"
                      :key="type.id"
                      :disabled="type.disable"
                      :label="type.name"
                      :value="type.id"
                    ></el-option>
                  </el-select>
                </div>
                <div class="type_value">
                  <el-radio-group v-model="item.type">
                    <el-radio :label="0" class="dblock">
                      享受折扣
                      <el-input
                        v-model="item.discount"
                        class="input_box_mini numberInputStyle"
                        size="mini"
                        :max="9"
                        :min="1"
                        type="number"
                        @focus="inputFocus(2, index, 0)"
                      >
                      </el-input>
                      折
                    </el-radio>
                    <el-radio :label="1" class="dblock">
                      每升优惠
                      <el-input
                        v-model="item.money"
                        class="input_box_mini"
                        size="mini"
                        @focus="inputFocus(2, index, 1)"
                      >
                      </el-input>
                      元
                    </el-radio>
                    <el-radio v-if="limit == 2" :label="2" class="dblock">
                      直减
                      <el-input
                        v-model="item.dec_money"
                        class="input_box_mini"
                        size="mini"
                        @focus="inputFocus(2, index, 2)"
                      >
                      </el-input>
                      元
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="type_del">
                  <el-button
                    icon="el-icon-close"
                    size="mini"
                    type="danger"
                    @click="delTypeItem(index, 2)"
                  ></el-button>
                </div>
              </div>
              <div class="add_button">
                <el-button size="small" type="primary" @click="addTypeItem(2)"
                  >增加规则
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="适用场景">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in checkList_option" :key="item.payment_code" :label="item.payment_code">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="互斥规则" v-if="IsShow == 2">
          <el-checkbox-group v-model="mutex">
            <el-checkbox label="1">积分</el-checkbox>
            <el-checkbox label="2">优惠券</el-checkbox>
            <el-checkbox label="3">会员折扣</el-checkbox>
            <el-checkbox label="5">充值优惠</el-checkbox>
            <el-checkbox label="6">余额</el-checkbox>
          </el-checkbox-group>
          <div v-if="mutex.length > 0">
            <div>
              优先适用顺序
            </div>
            <el-tag
              v-for="(items, indexs) in mutex"
              :key="indexs"
              style="margin-left: 5px;"
            >
              {{
                indexs +
                  1 +
                  " " +
                  (items == 1
                    ? "积分"
                    : items == 2
                    ? "优惠券"
                    : items == 3
                    ? "会员折扣"
                    : "充值优惠")
              }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item v-if="IsShow == 2" label="此卡排序优先级">
          <el-input-number v-model="formData.sort"></el-input-number>
          <div>提示:数字越大优先级越高</div>
        </el-form-item>
        <div v-if="IsShow == 2">
          <el-form-item
            label="设置当前卡有效期"
            v-if="card_type == 1 || card_type == 2"
          >
            <el-input v-model="formData.day" style="width: 50px;"></el-input>
            <span> 天 </span>
            <el-input v-model="formData.hour" style="width: 50px;"></el-input>
            <span> 时 </span>
            <el-input v-model="formData.minute" style="width: 50px;"></el-input>
            <span> 分 </span>
            <el-input v-model="formData.second" style="width: 50px;"></el-input>
            <span> 秒 </span>
          </el-form-item>
        </div>
        <el-form-item v-if="IsShow == 2" label="第一次是否享受优惠">
          <el-radio-group v-model="formData.is_first_discount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="IsShow == 2" label="是否开启当前优惠">
          <el-radio-group v-model="formData.is_open">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="IsShow == 0">
          <el-form-item label="是否需要购买">
            <el-radio-group v-model="formData.is_pay">
              <el-radio :label="1">需要</el-radio>
              <el-radio :label="0">免费</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="formData.is_pay" label="价格(元)">
            <el-input-number
              v-model="formData.money"
              :controls="false"
              class="input_box_small"
            ></el-input-number>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="赠送内容">
            <div class="margin10">
              <el-checkbox v-model="formData.is_coupon" class="minWidth">
                优惠券
              </el-checkbox>
              <div class="padding10">
                <el-tag
                  v-for="(tag, index) in sList"
                  :key="tag.id"
                  closable
                  style="margin-bottom:5px;margin-right:5px;"
                  @close="delTagItem(index)"
                >
                  <!-- {{ tag.name }} -->
                  {{ tag.name }}
                  <span v-if="tag.choseNum != 1">
                    <span class="colorRed">×</span>
                    {{ tag.choseNum }} 张</span
                  >
                </el-tag>
                <div class="buttonInput" @click="showSelecter = true">
                  添加券
                </div>
              </div>
            </div>
            <div class="margin10">
              <el-checkbox v-model="formData.is_points" class="minWidth">
                积分
              </el-checkbox>
              <div class="padding10">
                送
                <div class="smallinput">
                  <el-input v-model="formData.points" size="mini"></el-input>
                </div>
                积分
              </div>
            </div>
            <div class="margin10">
              <el-checkbox v-model="formData.is_grow_points" class="minWidth">
                成长值
              </el-checkbox>
              <div class="padding10">
                送
                <div class="smallinput">
                  <el-input
                    v-model="formData.grow_points"
                    size="mini"
                  ></el-input>
                </div>
                成长值 成长值仅适用于此卡会员
              </div>
            </div>
            <div class="margin10">
              <el-checkbox v-model="formData.is_balance" class="minWidth">
                余额
              </el-checkbox>
              <div class="padding10">
                送
                <div class="smallinput">
                  <el-input v-model="formData.balance" size="mini"></el-input>
                </div>
                元
              </div>
            </div>
          </el-form-item>
          <!-- 新增 -->
          <el-form-item label="是否为永久">
            <el-radio-group v-model="formData.is_forever">
              <el-radio :label="1">永久</el-radio>
              <el-radio :label="0">非永久</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="formData.is_forever == 0" label="有效时间(天)">
            <el-input-number
              v-model="formData.valid_date"
              :controls="false"
              class="input_box_small"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-radio-group v-model="formData.is_show">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否默认">
            <el-radio-group v-model="formData.is_default">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item v-if="IsShow == 1" label="是否开启活动">
          <el-radio-group v-model="is_open">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button :loading="uploadLoading" type="primary" @click="submit()"
          >提交
        </el-button>
        <el-button v-if="IsShow !== 1 && !LM" @click="goback()"
          >返回列表</el-button
        >
      </div>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        :jude="2"
        :sList="sList"
        @close="showSelecter = false"
        @getCommod="getCommod"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex";
import {
  addLevel,
  detailLevel,
  editLevel,
  getOilSortList,
  goodsOptions,
  visitor_discount_configDetail,
} from "@/api/vip";
import { getPayWay } from "@/api/pointSetting";
import { platformcard_card_detail } from "@/api/platform_card";
import balance from "../../pay/balance";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    newSelectCommodityNum,
  },
  props: {
    IsShow: {
      type: Number,
      default: 0,
    },
    LM: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log(this.IsShow);
    this.init();
    this.monthOptions = new Array(31)
      .toString()
      .split(",")
      .map(function(item, index) {
        var realNum = index + 1;
        if (realNum < 10) {
          return "0" + realNum;
        } else {
          return realNum;
        }
      });
  },
  created() {},
  data() {
    return {
      resource: 1,
      card_type: "",
      // : 0,key
      formData: {},
      mutex: [],
      // 上传图标
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      image_id: "", //上传后服务器路径
      // 上传背景
      imageUrl2: "", //上传的图片地址
      imgdata2: {}, //上传图片附加信息
      image_id2: "", //上传后服务器路径
      if_add: true, //是否是新添加
      loading: false, //页面loading
      uploadLoading: false, //上传时loading
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
      type_options: [], //油品类别选项
      type_discount_list: [], //按类型优惠
      oils_options: [], //油品选项
      oils_discount_list: [], //按油品优惠
      unified_type: 0, //统一优惠方式 0:折扣 1:每升减价
      unified_type_value: {
        //统一优惠方式
        type: 0,
        discount: "",
        money: "",
      },
      listLength: 1, //已有会员卡列表
      timeType: 0, //有效时间类型 0:长期有效 1:固定时间段 2:按周期重复
      dateValue: [], //固定时间段
      periodType: "0", //按周期你
      dayTimeValue: ["00:00", "23:59"], //每天重复
      monthDayValue: [], //每月重复 日
      monthTimeValue: ["00:00", "23:59"], //每月重复 时间
      monthOptions: [], //每月重复 日 选择项
      is_open: 0,
      weekDayValue: [
        {
          value: "1",
          name: "周一",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: {
                  type: 0,
                  discount: "",
                  money: "",
                },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: {
                      type: 0,
                      discount: "",
                      money: "",
                    },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "2",
          name: "周二",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "3",
          name: "周三",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "4",
          name: "周四",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "5",
          name: "周五",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "6",
          name: "周六",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          value: "7",
          name: "周七",
          rule: [
            {
              stime: "",
              etime: "",
              full_reduction: 0,
              every_money: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
              discountList: [
                {
                  num: "",
                  discount_type: 0,
                  discount: {
                    unified_offer_value: { type: 0, discount: "", money: "" },
                    cate_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                    goods_offer_value: [
                      { id: "", money: "", discount: "", type: 0 },
                    ],
                  },
                },
              ],
            },
          ],
        },
      ], //每周重复 日
      weekTimeValue: ["00:00", "23:59"], //每周重复 时间
      weekOptions: [
        { value: "1", name: "周一" },
        { value: "2", name: "周二" },
        { value: "3", name: "周三" },
        { value: "4", name: "周四" },
        { value: "5", name: "周五" },
        { value: "6", name: "周六" },
        { value: "7", name: "周日" },
      ], //每周重复 选择项
      checkList: [], //适用场景
      checkList_option: [], //使用场景选项
      showAddWeek: false, // 显示选择星期
      selectWeekItem: "", // 选择添加的星期
      gid: "", // 会员卡组id
      week_unify: "1", // 按周优惠时 1.统一优惠 0.每天自定义
      weekSetList: [], // 按周优惠 自定义每天
      limit: 0, // 优惠限制 0.无限制 1.区间满减 2.每满减
      discountList: [
        {
          discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
          type_options: [], //油品类别选项
          type_discount_list: [], //按类型优惠
          oils_options: [], //油品选项
          oils_discount_list: [], //按油品优惠
          unified_offer: 0, //统一优惠方式 0:折扣 1:每升减价
          unified_offer_value: {
            //统一优惠方式
            type: 0,
            discount: "",
            money: "",
          },
        },
      ], // 分段优惠列表
      everyMoney: "", // 每满优惠
    };
  },

  methods: {
    init() {
      this.gid = this.$route.query.gid;
      if (this.IsShow !== 1) {
        this.formData = {
          is_forever: 1,
          is_pay: 1,
          is_show: 1,
          is_default: 0,
        };
      }

      this.$nextTick(() => {
        // 获取油品类别选项
        getOilSortList(this.token, this.app_id).then((res) => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.type_options = res.data;
            } else {
              this.$message("暂无油品类别数据...");
            }
          } else {
            this.$message("暂无油品类别数据...");
          }
        });
        // 获取油品选项
        goodsOptions({ token: this.token, app_id: this.app_id }).then((res) => {
          if (res.code == 200) {
            res.data.forEach((item) => {
              this.oils_options.push({ id: String(item.id), name: item.name });
            });
          } else {
            // this.$message({
            //   type: "error",
            //   message: "获取油品列表失败，请刷新重试"
            // })
          }
        });
        getPayWay({ token: this.token, app_id: this.app_id, type: 2 }).then(
          (res) => {
            if (res.code == 200) {
              this.checkList_option = res.data;
            } else {
              this.$message(res.msg);
            }
          }
        );
      });
      //判断是否是编辑会员卡
      if (this.IsShow == 0) {
        if (this.$route.query.vid) {
          this.loading = true;
          this.if_add = false;
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: this.$route.query.vid,
          };
          detailLevel(data).then((res) => {
            console.log("表单详情", res);
            if (res.code == 200) {
              this.formData = Object.assign({}, res.data);
              this.image_id = res.data.icon;
              this.image_id2 = res.data.image;
              this.imageUrl = res.data.icon_url;
              this.imageUrl2 = res.data.image_url;

              let arrIds = this.formData.coupon_ids.split(",");
              let coupons = res.data.coupon;

              for (let i = 0; i < coupons.length; i++) {
                console.log("coupons", i);
                let choseNum = "0";
                for (let j = 0; j < arrIds.length; j++) {
                  if (coupons[i].id == arrIds[j]) {
                    choseNum++;
                  }
                }
                var obj = {};
                obj.choseNum = choseNum;
                obj.id = coupons[i].id;
                obj.name = coupons[i].title;
                obj.url =
                  "https://yckj-common.oss-cn-beijing.aliyuncs.com/1576482532.jpg";
                this.sList.push(obj);
              }
              console.log("this.sList", this.sList);
              if (this.IsShow == 0) {
                this.formData.is_coupon = Boolean(
                  Number(this.formData.is_coupon || 0)
                );
                this.formData.is_points = Boolean(
                  Number(this.formData.is_points || 0)
                );
                this.formData.is_grow_points = Boolean(
                  Number(this.formData.is_grow_points || 0)
                );
                this.formData.is_balance = Boolean(
                  Number(this.formData.is_balance || 0)
                );
                console.log("jia", this.formData);
              }

              // this.formData.discount = this.formData.discount / 10;
              if (this.formData.full_reduction == 1) {
                // 优惠限制 满减
                this.limit = 1;
                var values = Object.values(this.formData.full_discount);
                var nums = Object.keys(this.formData.full_discount);
                this.discountList.splice(0, 1);
                values.forEach((di, didx) => {
                  console.log(di);
                  var disItem = {
                    num: nums[didx],
                    discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
                    type_options: [], //油品类别选项
                    type_discount_list: [], //按类型优惠
                    oils_options: [], //油品选项
                    oils_discount_list: [], //按油品优惠
                    unified_offer: 0, //统一优惠方式 0:折扣 1:每升减价 2:直减
                    unified_offer_value: {
                      //统一优惠方式
                      type: 0,
                      discount: "",
                      money: "",
                      dec_money: "",
                    },
                  };
                  if (di.unified_offer == "1") {
                    // 统一优惠
                    disItem.discount_type = 0;
                    disItem.unified_offer_value.type =
                      di.unified_offer_value.discount_status == 1
                        ? 0
                        : di.unified_offer_value.money_status == 1
                        ? 1
                        : di.unified_offer_value.dec_status == 1
                        ? 2
                        : "";
                    disItem.unified_offer_value.discount =
                      Number(di.unified_offer_value.discount) / 10 || "";
                    disItem.unified_offer_value.money =
                      di.unified_offer_value.money || "";
                  } else if (di.cate_offer == "1") {
                    // 按类别
                    disItem.discount_type = 1;
                    di.cate_offer_value.forEach((cate) => {
                      var cateItem = {
                        id: cate.cate,
                        type:
                          cate.discount_status == 1
                            ? 0
                            : cate.money_status == 1
                            ? 1
                            : cate.dec_status == 1
                            ? 2
                            : "",
                        discount: Number(cate.discount) / 10 || "",
                        money: cate.money || "",
                        dec_money: cate.dec_money || "",
                      };
                      disItem.type_discount_list.push(cateItem);
                    });
                  } else if (di.goods_offer == "1") {
                    disItem.discount_type = 2;
                    di.goods_offer_value.forEach((goods) => {
                      var goodsItem = {
                        id: goods.goods,
                        type:
                          goods.discount_status == 1
                            ? 0
                            : goods.money_status == 1
                            ? 1
                            : goods.dec_status == 1
                            ? 2
                            : "",
                        discount: Number(goods.discount) / 10 || "",
                        money: goods.money || "",
                        dec_money: goods.dec_money || "",
                      };
                      disItem.oils_discount_list.push(goodsItem);
                    });
                  }
                  console.log(disItem);
                  this.discountList.push(disItem);
                });
              } else if (this.formData.every_reduction == 1) {
                // 7.31 新增 每满减
                var k = Object.keys(this.formData.every_discount)[0];
                this.limit = 2;
                this.everyMoney = k;
                if (this.formData.every_discount[k].unified_offer == "1") {
                  this.discount_type = 0;
                  this.unified_type =
                    this.formData.every_discount[k].unified_offer_value
                      .discount_status == "1"
                      ? 0
                      : this.formData.every_discount[k].unified_offer_value
                          .money_status == "1"
                      ? 1
                      : this.formData.every_discount[k].unified_offer_value
                          .dec_status == "1"
                      ? 2
                      : "";
                  this.unified_type_value = {
                    discount:
                      Number(
                        this.formData.every_discount[k].unified_offer_value
                          .discount
                      ) / 10,
                    money: this.formData.every_discount[k].unified_offer_value
                      .money,
                    dec_money: this.formData.every_discount[k]
                      .unified_offer_value.dec_money,
                  };
                } else if (this.formData.every_discount[k].cate_offer == "1") {
                  this.discount_type = 1;
                  this.type_discount_list = [];
                  this.formData.every_discount[k].cate_offer_value.forEach(
                    (item) => {
                      var i = {
                        id: item.cate,
                        type:
                          item.discount_status == "1"
                            ? 0
                            : item.money_status == "1"
                            ? 1
                            : item.dec_status == "1"
                            ? 2
                            : "",
                        discount: Number(item.discount) / 10 || "",
                        money: item.money,
                        dec_money: item.dec_money,
                      };
                      this.type_discount_list.push(i);
                    }
                  );
                } else if (this.formData.every_discount[k].goods_offer == "1") {
                  this.discount_type = 2;
                  this.oils_discount_list = [];
                  this.formData.every_discount[k].goods_offer_value.forEach(
                    (item) => {
                      var i = {
                        id: item.goods,
                        type:
                          item.discount_status == "1"
                            ? 0
                            : item.money_status == "1"
                            ? 1
                            : item.dec_status == "1"
                            ? 2
                            : "",
                        discount: Number(item.discount) / 10 || "",
                        money: item.money,
                        dec_money: item.dec_money,
                      };
                      this.oils_discount_list.push(i);
                    }
                  );
                }
              } else {
                if (this.formData.unified_offer == "1") {
                  this.discount_type = 0;
                  this.unified_type =
                    this.formData.unified_offer_value.money_status == "1"
                      ? 1
                      : 0;
                  this.unified_type_value = {
                    discount:
                      Number(this.formData.unified_offer_value.discount) / 10,
                    money: this.formData.unified_offer_value.money,
                  };
                } else if (this.formData.cate_offer == "1") {
                  this.discount_type = 1;
                  this.type_discount_list = [];
                  console.log(this.formData);
                  if (this.formData.cate_offer_value) {
                    this.formData.cate_offer_value.forEach((item) => {
                      var i = {
                        id: item.cate,
                        type: item.discount_status == "1" ? 0 : 1,
                        discount: Number(item.discount) / 10 || "",
                        money: item.money,
                      };
                      this.type_discount_list.push(i);
                    });
                  }
                } else if (this.formData.goods_offer == "1") {
                  this.discount_type = 2;
                  this.oils_discount_list = [];
                  if (this.formData.goods_offer_value) {
                    this.formData.goods_offer_value.forEach((item) => {
                      var i = {
                        id: item.goods,
                        type: item.discount_status == "1" ? 0 : 1,
                        discount: Number(item.discount) / 10 || "",
                        money: item.money,
                      };
                      this.oils_discount_list.push(i);
                    });
                  }
                }
              }
              /**
               * 新增优惠时间处理
               */
              this.week_unify = res.data.week_unify;
              this.timeType = res.data.time_status;
              if (res.data.time_status == 1) {
                this.dateValue = [res.data.start_time, res.data.end_time];
              } else {
                if (res.data.day_status == 1) {
                  this.periodType = "0";
                  this.dayTimeValue = [
                    res.data.day_value.start_time,
                    res.data.day_value.end_time,
                  ];
                } else if (res.data.month_status == 1) {
                  this.periodType = "1";
                  this.monthDayValue = res.data.month_value.number.split(",");
                  this.monthTimeValue = [
                    res.data.month_value.start_time,
                    res.data.month_value.end_time,
                  ];
                } else if (res.data.week_status == 1) {
                  this.periodType = "2";
                  this.week_unify = String(res.data.week_unify);
                  var week = res.data.week_value.week;
                  if (week.Mon == "1") {
                    this.weekDayValue[0].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Mon, 0);
                  }
                  if (week.Tue == "1") {
                    this.weekDayValue[1].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Tue, 1);
                  }
                  if (week.Wed == "1") {
                    this.weekDayValue[2].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Wed, 2);
                  }
                  if (week.Thur == "1") {
                    this.weekDayValue[3].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Thur, 3);
                  }
                  if (week.Fri == "1") {
                    this.weekDayValue[4].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Fri, 4);
                  }
                  if (week.Sat == "1") {
                    this.weekDayValue[5].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Sat, 5);
                  }
                  if (week.Sun == "1") {
                    this.weekDayValue[6].rule.splice(0, 1);
                    this.dealRuleItem(res.data.week_value.rule.Sun, 6);
                  }
                }
              }
              delete this.formData.create_time;
              delete this.formData.is_del;
              delete this.formData.image_url;
              delete this.formData.icon_url;
            }
            this.loading = false;
            this.weekDayValue.forEach((item) => {
              var idx = this.weekOptions.findIndex(
                (x) => x.value == item.value
              );
              if (idx != -1) {
                this.weekOptions[idx].selected = true;
              }
            });
          });
        }
      }
      if (this.IsShow == 1) {
        this.sanke_info();
      }
      if (this.IsShow == 2) {
        this.set_card_info();
      }
    },
    //散客详情
    sanke_info() {
      this.loading = true;
      this.if_add = false;
      visitor_discount_configDetail({ app_id: this.app_id }).then((res) => {
        console.log("表单详情", res);
        if (res.code == 200) {
          let Dataed = res.data.discount;
          this.formData = Object.assign({}, Dataed);
          this.is_open = res.data.is_open;
          console.log(this.formData);
          if (this.formData.full_reduction == 1) {
            // 优惠限制 满减
            this.limit = 1;
            var values = Object.values(this.formData.full_discount);
            var nums = Object.keys(this.formData.full_discount);
            this.discountList.splice(0, 1);
            values.forEach((di, didx) => {
              console.log(di);
              var disItem = {
                num: nums[didx],
                discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
                type_options: [], //油品类别选项
                type_discount_list: [], //按类型优惠
                oils_options: [], //油品选项
                oils_discount_list: [], //按油品优惠
                unified_offer: 0, //统一优惠方式 0:折扣 1:每升减价 2:直减
                unified_offer_value: {
                  //统一优惠方式
                  type: 0,
                  discount: "",
                  money: "",
                  dec_money: "",
                },
              };
              if (di.unified_offer == "1") {
                // 统一优惠
                disItem.discount_type = 0;
                disItem.unified_offer_value.type =
                  di.unified_offer_value.discount_status == 1
                    ? 0
                    : di.unified_offer_value.money_status == 1
                    ? 1
                    : di.unified_offer_value.dec_status == 1
                    ? 2
                    : "";
                disItem.unified_offer_value.discount =
                  Number(di.unified_offer_value.discount) / 10 || "";
                disItem.unified_offer_value.money =
                  di.unified_offer_value.money || "";
                disItem.unified_offer_value.dec_money =
                  di.unified_offer_value.dec_money || "";
              } else if (di.cate_offer == "1") {
                // 按类别
                disItem.discount_type = 1;
                di.cate_offer_value.forEach((cate) => {
                  var cateItem = {
                    id: cate.cate,
                    type:
                      cate.discount_status == 1
                        ? 0
                        : cate.money_status == 1
                        ? 1
                        : cate.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(cate.discount) / 10 || "",
                    money: cate.money || "",
                    dec_money: cate.dec_money || "",
                  };
                  disItem.type_discount_list.push(cateItem);
                });
              } else if (di.goods_offer == "1") {
                disItem.discount_type = 2;
                di.goods_offer_value.forEach((goods) => {
                  var goodsItem = {
                    id: goods.goods,
                    type:
                      goods.discount_status == 1
                        ? 0
                        : goods.money_status == 1
                        ? 1
                        : goods.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(goods.discount) / 10 || "",
                    money: goods.money || "",
                    dec_money: goods.dec_money || "",
                  };
                  disItem.oils_discount_list.push(goodsItem);
                });
              }
              console.log(disItem);
              this.discountList.push(disItem);
            });
          } else if (this.formData.every_reduction == 1) {
            // 7.31 新增 每满减
            var k = Object.keys(this.formData.every_discount)[0];
            this.limit = 2;
            this.everyMoney = k;
            if (this.formData.every_discount[k].unified_offer == "1") {
              this.discount_type = 0;
              this.unified_type =
                this.formData.every_discount[k].unified_offer_value
                  .discount_status == "1"
                  ? 0
                  : this.formData.every_discount[k].unified_offer_value
                      .money_status == "1"
                  ? 1
                  : this.formData.every_discount[k].unified_offer_value
                      .dec_status == "1"
                  ? 2
                  : "";
              this.unified_type_value = {
                discount:
                  Number(
                    this.formData.every_discount[k].unified_offer_value.discount
                  ) / 10,
                money: this.formData.every_discount[k].unified_offer_value
                  .money,
                dec_money: this.formData.every_discount[k].unified_offer_value
                  .dec_money,
              };
            } else if (this.formData.every_discount[k].cate_offer == "1") {
              this.discount_type = 1;
              this.type_discount_list = [];
              this.formData.every_discount[k].cate_offer_value.forEach(
                (item) => {
                  var i = {
                    id: item.cate,
                    type:
                      item.discount_status == "1"
                        ? 0
                        : item.money_status == "1"
                        ? 1
                        : item.dec_status == "1"
                        ? 2
                        : "",
                    discount: Number(item.discount) / 10 || "",
                    money: item.money,
                    dec_money: item.dec_money,
                  };
                  this.type_discount_list.push(i);
                }
              );
            } else if (this.formData.every_discount[k].goods_offer == "1") {
              this.discount_type = 2;
              this.oils_discount_list = [];
              this.formData.every_discount[k].goods_offer_value.forEach(
                (item) => {
                  var i = {
                    id: item.goods,
                    type:
                      item.discount_status == "1"
                        ? 0
                        : item.money_status == "1"
                        ? 1
                        : item.dec_status == "1"
                        ? 2
                        : "",
                    discount: Number(item.discount) / 10 || "",
                    money: item.money,
                    dec_money: item.dec_money,
                  };
                  this.oils_discount_list.push(i);
                }
              );
            }
          } else {
            if (this.formData.unified_offer == "1") {
              this.discount_type = 0;
              this.unified_type =
                this.formData.unified_offer_value.money_status == "1" ? 1 : 0;
              this.unified_type_value = {
                discount:
                  Number(this.formData.unified_offer_value.discount) / 10,
                money: this.formData.unified_offer_value.money,
              };
            } else if (this.formData.cate_offer == "1") {
              this.discount_type = 1;
              this.type_discount_list = [];
              this.formData.cate_offer_value.forEach((item) => {
                var i = {
                  id: item.cate,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money,
                };
                this.type_discount_list.push(i);
              });
            } else if (this.formData.goods_offer == "1") {
              this.discount_type = 2;
              this.oils_discount_list = [];
              this.formData.goods_offer_value.forEach((item) => {
                var i = {
                  id: item.goods,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money,
                };
                this.oils_discount_list.push(i);
              });
            }
          }
          /**
           * 新增优惠时间处理
           */
          this.week_unify = Dataed.week_unify;
          this.timeType = Dataed.time_status;
          if (Dataed.time_status == 1) {
            this.dateValue = [Dataed.start_time, Dataed.end_time];
          } else {
            if (Dataed.day_status == 1) {
              this.periodType = "0";
              this.dayTimeValue = [
                Dataed.day_value.start_time,
                Dataed.day_value.end_time,
              ];
            } else if (Dataed.month_status == 1) {
              this.periodType = "1";
              this.monthDayValue = Dataed.month_value.number.split(",");
              this.monthTimeValue = [
                Dataed.month_value.start_time,
                Dataed.month_value.end_time,
              ];
            } else if (Dataed.week_status == 1) {
              this.periodType = "2";
              this.week_unify = String(Dataed.week_unify);
              var week = Dataed.week_value.week;
              if (week.Mon == "1") {
                this.weekDayValue[0].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Mon, 0);
              }
              if (week.Tue == "1") {
                this.weekDayValue[1].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Tue, 1);
              }
              if (week.Wed == "1") {
                this.weekDayValue[2].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Wed, 2);
              }
              if (week.Thur == "1") {
                this.weekDayValue[3].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Thur, 3);
              }
              if (week.Fri == "1") {
                this.weekDayValue[4].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Fri, 4);
              }
              if (week.Sat == "1") {
                this.weekDayValue[5].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Sat, 5);
              }
              if (week.Sun == "1") {
                this.weekDayValue[6].rule.splice(0, 1);
                this.dealRuleItem(Dataed.week_value.rule.Sun, 6);
              }
            }
          }
          delete this.formData.create_time;
          delete this.formData.is_del;
          delete this.formData.image_url;
          delete this.formData.icon_url;
        }
        this.loading = false;
        this.weekDayValue.forEach((item) => {
          var idx = this.weekOptions.findIndex((x) => x.value == item.value);
          if (idx != -1) {
            this.weekOptions[idx].selected = true;
          }
        });
      });
    },
    //平台卡详情
    set_card_info() {
      this.loading = true;
      this.if_add = false;
      platformcard_card_detail({
        app_id: this.app_id,
        id: this.$route.query.id,
      }).then((res) => {
        console.log("表单详情", res);
        if (res.code == 200) {
          this.card_type = res.data.card_type;
          let Dataed = res.data.platform_card_data;
          this.formData = Object.assign({}, Dataed);
          this.mutex = Dataed.is_mutex ? Dataed.is_mutex.split(",") : [];
          console.log(Dataed.is_mutex.split(",").length);
          // this.is_open = res.data.is_open;
          console.log(this.formData);
          if (this.formData.full_reduction == 1) {
            // 优惠限制 满减
            this.limit = 1;
            var values = Object.values(this.formData.full_discount);
            var nums = Object.keys(this.formData.full_discount);
            this.discountList.splice(0, 1);
            values.forEach((di, didx) => {
              console.log(di);
              var disItem = {
                num: nums[didx],
                discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
                type_options: [], //油品类别选项
                type_discount_list: [], //按类型优惠
                oils_options: [], //油品选项
                oils_discount_list: [], //按油品优惠
                unified_offer: 0, //统一优惠方式 0:折扣 1:每升减价 2:直减
                unified_offer_value: {
                  //统一优惠方式
                  type: 0,
                  discount: "",
                  money: "",
                  dec_money: "",
                },
              };
              if (di.unified_offer == "1") {
                // 统一优惠
                disItem.discount_type = 0;
                disItem.unified_offer_value.type =
                  di.unified_offer_value.discount_status == 1
                    ? 0
                    : di.unified_offer_value.money_status == 1
                    ? 1
                    : di.unified_offer_value.dec_status == 1
                    ? 2
                    : "";
                disItem.unified_offer_value.discount =
                  Number(di.unified_offer_value.discount) / 10 || "";
                disItem.unified_offer_value.money =
                  di.unified_offer_value.money || "";
                disItem.unified_offer_value.dec_money =
                  di.unified_offer_value.dec_money || "";
              } else if (di.cate_offer == "1") {
                // 按类别
                disItem.discount_type = 1;
                di.cate_offer_value.forEach((cate) => {
                  var cateItem = {
                    id: cate.cate,
                    type:
                      cate.discount_status == 1
                        ? 0
                        : cate.money_status == 1
                        ? 1
                        : cate.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(cate.discount) / 10 || "",
                    money: cate.money || "",
                    dec_money: cate.dec_money || "",
                  };
                  disItem.type_discount_list.push(cateItem);
                });
              } else if (di.goods_offer == "1") {
                disItem.discount_type = 2;
                di.goods_offer_value.forEach((goods) => {
                  var goodsItem = {
                    id: goods.goods,
                    type:
                      goods.discount_status == 1
                        ? 0
                        : goods.money_status == 1
                        ? 1
                        : goods.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(goods.discount) / 10 || "",
                    money: goods.money || "",
                    dec_money: goods.dec_money || "",
                  };
                  disItem.oils_discount_list.push(goodsItem);
                });
              }
              console.log(disItem);
              this.discountList.push(disItem);
            });
          } else if (this.formData.every_reduction == 1) {
            // 7.31 新增 每满减
            var k = Object.keys(this.formData.every_discount)[0];
            this.limit = 2;
            this.everyMoney = k;
            if (this.formData.every_discount[k].unified_offer == "1") {
              this.discount_type = 0;
              this.unified_type =
                this.formData.every_discount[k].unified_offer_value
                  .discount_status == "1"
                  ? 0
                  : this.formData.every_discount[k].unified_offer_value
                      .money_status == "1"
                  ? 1
                  : this.formData.every_discount[k].unified_offer_value
                      .dec_status == "1"
                  ? 2
                  : "";
              this.unified_type_value = {
                discount:
                  Number(
                    this.formData.every_discount[k].unified_offer_value.discount
                  ) / 10,
                money: this.formData.every_discount[k].unified_offer_value
                  .money,
                dec_money: this.formData.every_discount[k].unified_offer_value
                  .dec_money,
              };
            } else if (this.formData.every_discount[k].cate_offer == "1") {
              this.discount_type = 1;
              this.type_discount_list = [];
              this.formData.every_discount[k].cate_offer_value.forEach(
                (item) => {
                  var i = {
                    id: item.cate,
                    type:
                      item.discount_status == "1"
                        ? 0
                        : item.money_status == "1"
                        ? 1
                        : item.dec_status == "1"
                        ? 2
                        : "",
                    discount: Number(item.discount) / 10 || "",
                    money: item.money,
                    dec_money: item.dec_money,
                  };
                  this.type_discount_list.push(i);
                }
              );
            } else if (this.formData.every_discount[k].goods_offer == "1") {
              this.discount_type = 2;
              this.oils_discount_list = [];
              this.formData.every_discount[k].goods_offer_value.forEach(
                (item) => {
                  var i = {
                    id: item.goods,
                    type:
                      item.discount_status == "1"
                        ? 0
                        : item.money_status == "1"
                        ? 1
                        : item.dec_status == "1"
                        ? 2
                        : "",
                    discount: Number(item.discount) / 10 || "",
                    money: item.money,
                    dec_money: item.dec_money,
                  };
                  this.oils_discount_list.push(i);
                }
              );
            }
          } else {
            if (this.formData.unified_offer == "1") {
              this.discount_type = 0;
              this.unified_type =
                this.formData.unified_offer_value.money_status == "1" ? 1 : 0;
              this.unified_type_value = {
                discount:
                  Number(this.formData.unified_offer_value.discount) / 10,
                money: this.formData.unified_offer_value.money,
              };
            } else if (this.formData.cate_offer == "1") {
              this.discount_type = 1;
              this.type_discount_list = [];
              this.formData.cate_offer_value.forEach((item) => {
                var i = {
                  id: item.cate,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money,
                };
                this.type_discount_list.push(i);
              });
            } else if (this.formData.goods_offer == "1") {
              this.discount_type = 2;
              this.oils_discount_list = [];
              this.formData.goods_offer_value.forEach((item) => {
                var i = {
                  id: item.goods,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money,
                };
                this.oils_discount_list.push(i);
              });
            }
          }
          delete this.formData.create_time;
          delete this.formData.is_del;
          delete this.formData.image_url;
          delete this.formData.icon_url;
        }
        this.loading = false;
        this.weekDayValue.forEach((item) => {
          var idx = this.weekOptions.findIndex((x) => x.value == item.value);
          if (idx != -1) {
            this.weekOptions[idx].selected = true;
          }
        });
      });
    },
    // 处理星期几的rule
    dealRuleItem(arr, i) {
      arr.forEach((r) => {
        var itemData = {
          stime: r.time.split(",")[0],
          etime: r.time.split(",")[1],
          discount_type: 0,
          full_reduction: 0,
          every_money: "",
          discount: {
            unified_offer_value: { type: 0, discount: "", money: "" },
            cate_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
            goods_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
          },
          discountList: [
            {
              num: "",
              discount_type: 0,
              discount: {
                unified_offer_value: { type: 0, discount: "", money: "" },
                cate_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
                goods_offer_value: [
                  { id: "", money: "", discount: "", type: 0 },
                ],
              },
            },
          ],
        };
        if (this.week_unify == "1") {
          // 统一优惠 不处理优惠内容
        } else {
          if (r.full_reduction == "1") {
            //满减
            itemData.full_reduction = 1;
            itemData.discountList.splice(0, 1);
            var dList = Object.values(r.full_discount);
            var nums = Object.keys(r.full_discount);
            // var cList = [];
            dList.forEach((di, didx) => {
              // 遍历对象的值 处理分阶段满减
              console.log(di);
              var ci = {
                num: "",
                discount_type: 0,
                discount: {
                  unified_offer_value: { type: 0, discount: "", money: "" },
                  cate_offer_value: [
                    { id: "", money: "", discount: "", type: 0 },
                  ],
                  goods_offer_value: [
                    { id: "", money: "", discount: "", type: 0 },
                  ],
                },
              };
              ci.num = nums[didx];
              if (di.unified_offer == 1) {
                // 满减 统一优惠
                ci.discount_type = 0;
                ci.discount.unified_offer_value.type =
                  di.unified_offer_value.discount_status == 1
                    ? 0
                    : di.unified_offer_value.money_status == 1
                    ? 1
                    : di.unified_offer_value.dec_status == 1
                    ? 2
                    : "";
                ci.discount.unified_offer_value.discount =
                  Number(di.unified_offer_value.discount) / 10 || "";
                ci.discount.unified_offer_value.money =
                  di.unified_offer_value.money || "";
                ci.discount.unified_offer_value.dec_money =
                  di.unified_offer_value.dec_money || "";
              } else if (di.cate_offer == 1) {
                // 满减 按类别
                ci.discount_type = 1;
                ci.discount.cate_offer_value.splice(0, 1);
                di.cate_offer_value.forEach((cate) => {
                  var cateItem = {
                    id: cate.cate,
                    type:
                      cate.discount_status == 1
                        ? 0
                        : cate.money_status == 1
                        ? 1
                        : cate.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(cate.discount) / 10 || "",
                    money: cate.money || "",
                    dec_money: cate.dec_money || "",
                  };
                  ci.discount.cate_offer_value.push(cateItem);
                });
              } else if (di.goods_offer == 1) {
                // 满减 按油品
                ci.discount_type = 2;
                ci.discount.goods_offer_value.splice(0, 1);
                di.goods_offer_value.forEach((goods) => {
                  var goodsItem = {
                    id: goods.goods,
                    type:
                      goods.discount_status == 1
                        ? 0
                        : goods.money_status == 1
                        ? 1
                        : goods.dec_status == 1
                        ? 2
                        : "",
                    discount: Number(goods.discount) / 10 || "",
                    money: goods.money || "",
                    dec_money: goods.dec_money || "",
                  };
                  ci.discount.goods_offer_value.push(goodsItem);
                });
              }
              console.log(ci);
              itemData.discountList.push(ci);
            });
          } else if (r.every_reduction == "1") {
            // 7.31 新增 每满减
            itemData.full_reduction = 2;
            var k = Object.keys(r.every_discount)[0];
            itemData.every_money = k;
            if (r.every_discount[k].unified_offer == 1) {
              // 统一优惠
              itemData.discount_type = 0;
              itemData.discount.unified_offer_value.type =
                r.every_discount[k].unified_offer_value.discount_status == 1
                  ? 0
                  : r.every_discount[k].unified_offer_value.money_status == 1
                  ? 1
                  : r.every_discount[k].unified_offer_value.dec_status == 1
                  ? 2
                  : "";
              itemData.discount.unified_offer_value.discount =
                Number(r.every_discount[k].unified_offer_value.discount) / 10 ||
                "";
              itemData.discount.unified_offer_value.money =
                r.every_discount[k].unified_offer_value.money || "";
              itemData.discount.unified_offer_value.dec_money =
                r.every_discount[k].unified_offer_value.dec_money || "";
            } else if (r.every_discount[k].cate_offer == 1) {
              // 按类别优惠
              itemData.discount_type = 1;
              itemData.discount.cate_offer_value.splice(0, 1);
              r.every_discount[k].cate_offer_value.forEach((cate) => {
                var cateItem = {
                  id: cate.cate,
                  type:
                    cate.discount_status == 1
                      ? 0
                      : cate.money_status == 1
                      ? 1
                      : cate.dec_status == 1
                      ? 2
                      : "",
                  discount: Number(cate.discount) / 10 || "",
                  money: cate.money || "",
                  dec_money: cate.dec_money || "",
                };
                itemData.discount.cate_offer_value.push(cateItem);
              });
            } else if (r.every_discount[k].goods_offer == 1) {
              // 按油品优惠
              itemData.discount_type = 2;
              itemData.discount.goods_offer_value.splice(0, 1);
              r.every_discount[k].goods_offer_value.forEach((goods) => {
                var goodsItem = {
                  id: goods.goods,
                  type:
                    goods.discount_status == 1
                      ? 0
                      : goods.money_status == 1
                      ? 1
                      : goods.dec_status == 1
                      ? 2
                      : "",
                  discount: Number(goods.discount) / 10 || "",
                  money: goods.money || "",
                  dec_money: goods.dec_money || "",
                };
                itemData.discount.goods_offer_value.push(goodsItem);
              });
            }
          } else {
            if (r.discount.unified_offer == 1) {
              // 统一优惠
              itemData.discount_type = 0;
              itemData.discount.unified_offer_value.type =
                r.discount.unified_offer_value.discount_status == 1 ? 0 : 1;
              itemData.discount.unified_offer_value.discount =
                Number(r.discount.unified_offer_value.discount) / 10 || "";
              itemData.discount.unified_offer_value.money =
                r.discount.unified_offer_value.money || "";
            } else if (r.discount.cate_offer == 1) {
              // 按类别优惠
              itemData.discount_type = 1;
              itemData.discount.cate_offer_value.splice(0, 1);
              r.discount.cate_offer_value.forEach((cate) => {
                var cateItem = {
                  id: cate.cate,
                  type: cate.discount_status == 1 ? 0 : 1,
                  discount: Number(cate.discount) / 10 || "",
                  money: cate.money || "",
                };
                itemData.discount.cate_offer_value.push(cateItem);
              });
            } else if (r.discount.goods_offer == 1) {
              // 按油品优惠
              itemData.discount_type = 2;
              itemData.discount.goods_offer_value.splice(0, 1);
              r.discount.goods_offer_value.forEach((goods) => {
                var goodsItem = {
                  id: goods.goods,
                  type: goods.discount_status == 1 ? 0 : 1,
                  discount: Number(goods.discount) / 10 || "",
                  money: goods.money || "",
                };
                itemData.discount.goods_offer_value.push(goodsItem);
              });
            }
          }
        }
        this.weekDayValue[i].rule.push(itemData);
      });
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
    closeDialog() {
      this.showAdd = false;
    },
    submit() {
      this.save();
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      // data.icon = this.image_id; //图标
      // data.image = this.image_id2; //背景
      if (this.IsShow == 0) {
        data.explain = "1";
        data.token = this.token;
        data.group_id = this.gid;
        data.app_id = this.app_id;
      }
      // 新增内容
      // var ids = [];
      let arrCountId = [];
      this.sList.forEach((item) => {
        // if(item.choseNum)
        for (var n = 0; n < Number(item.choseNum); n++) {
          arrCountId.push(item.id);
        }
      });
      if (this.IsShow == 0) {
        data.coupon_ids = arrCountId.join(",");
        data.is_coupon = data.is_coupon ? 1 : 0;
        data.is_points = data.is_points ? 1 : 0;
        data.is_grow_points = data.is_grow_points ? 1 : 0;
        data.is_balance = data.is_balance ? 1 : 0;
      }

      data.unified_offer = "0";
      data.cate_offer = "0";
      data.goods_offer = "0";
      if (
        this.timeType == 2 &&
        this.periodType == "2" &&
        this.week_unify == "0"
      ) {
        console.log("按周期，按周，每天自定义");
      } else {
        if (this.limit == 1) {
          // 满减区间
          data.full_reduction = 1;
          data.every_reduction = 0;
          var full_discount = {};
          this.discountList.forEach((item) => {
            var dItem = {};
            console.log(item);
            if (item.discount_type == 0) {
              // 满减区间 统一优惠
              dItem.unified_offer = "1";
              dItem.unified_offer_value = {};
              if (item.unified_offer_value.type == 0) {
                dItem.unified_offer_value.discount_status = 1;
                dItem.unified_offer_value.discount =
                  Number(item.unified_offer_value.discount) * 10 || 100;
                dItem.unified_offer_value.dis_str = `满${item.num}元${item.unified_offer_value.discount}折优惠`;
              } else if (item.unified_offer_value.type == 1) {
                dItem.unified_offer_value.money_status = 1;
                dItem.unified_offer_value.money =
                  item.unified_offer_value.money;
                dItem.unified_offer_value.dis_str = `满${item.num}元每升优惠${item.unified_offer_value.money}元`;
              } else if (item.unified_offer_value.type == 2) {
                dItem.unified_offer_value.dec_status = 1;
                dItem.unified_offer_value.dec_money =
                  item.unified_offer_value.dec_money;
                dItem.unified_offer_value.dis_str = `满${item.num}元优惠${item.unified_offer_value.dec_money}元`;
              }
            } else if (item.discount_type == 1) {
              // 满减区间 按类别优惠
              dItem.cate_offer = "1";
              dItem.cate_offer_value = [];
              item.type_discount_list.forEach((cate) => {
                var cateItem = {
                  cate: cate.id,
                };
                if (cate.type == 0) {
                  cateItem.discount_status = 1;
                  cateItem.discount = Number(cate.discount) * 10 || 100;
                  cateItem.dis_str = `满${item.num}元${
                    this.type_options.find((x) => x.id == cate.id).name
                  }${cate.discount}折优惠`;
                } else if (cate.type == 1) {
                  cateItem.money_status = 1;
                  cateItem.money = cate.money;
                  cateItem.dis_str = `满${item.num}元${
                    this.type_options.find((x) => x.id == cate.id).name
                  }每升优惠${cate.money}元`;
                } else if (cate.type == 2) {
                  cateItem.dec_status = 1;
                  cateItem.dec_money = cate.dec_money;
                  cateItem.dis_str = `满${item.num}元${
                    this.type_options.find((x) => x.id == cate.id).name
                  }优惠${cate.dec_money}元`;
                }
                dItem.cate_offer_value.push(cateItem);
              });
            } else if (item.discount_type == 2) {
              // 满减区间 按油品优惠
              dItem.goods_offer = "1";
              dItem.goods_offer_value = [];
              item.oils_discount_list.forEach((goods) => {
                var goodItem = {
                  goods: goods.id,
                };
                if (goods.type == 0) {
                  goodItem.discount_status = 1;
                  goodItem.discount = Number(goods.discount) * 10 || 100;
                  goodItem.dis_str = `满${item.num}元${
                    this.oils_options.find((x) => x.id == goods.id).name
                  }汽油${goods.discount}折优惠`;
                } else if (goods.type == 1) {
                  goodItem.money_status = 1;
                  goodItem.money = goods.money;
                  goodItem.dis_str = `满${item.num}元${
                    this.oils_options.find((x) => x.id == goods.id).name
                  }汽油每升优惠${goods.money}元`;
                } else if (goods.type == 2) {
                  goodItem.dec_status = 1;
                  goodItem.dec_money = goods.dec_money;
                  goodItem.dis_str = `满${item.num}元${
                    this.oils_options.find((x) => x.id == goods.id).name
                  }汽油优惠${goods.dec_money}元`;
                }
                dItem.goods_offer_value.push(goodItem);
              });
            }
            console.log(dItem);
            var keyName = item.num;
            full_discount[keyName] = dItem;
          });
          data.full_discount = full_discount;
        } else if (this.limit == 2) {
          // 每满减
          data.every_reduction = 1;
          data.full_reduction = 0;
          data.every_discount = {};
          var everyDiscountData = {
            unified_offer: "0",
            cate_offer: "0",
            goods_offer: "0",
          };
          if (this.discount_type == 0) {
            everyDiscountData.unified_offer = "1";
            everyDiscountData.unified_offer_value = {
              discount_status: this.unified_type == 0 ? "1" : "0",
              discount:
                this.unified_type == 0
                  ? Number(this.unified_type_value.discount) * 10 || "100"
                  : "",
              money_status: this.unified_type == 1 ? "1" : "0",
              money:
                this.unified_type == 1 ? this.unified_type_value.money : "",
              dec_status: this.unified_type == 2 ? "1" : "0",
              dec_money:
                this.unified_type == 2 ? this.unified_type_value.dec_money : "",
              dis_str:
                this.unified_type == 0
                  ? `每满${this.everyMoney}元${this.unified_type_value.discount}折优惠`
                  : this.unified_type == 1
                  ? `每满${this.everyMoney}元每升优惠${this.unified_type_value.money}元`
                  : `每满${this.everyMoney}元优惠${this.unified_type_value.dec_money}元`,
            };
          }
          if (this.discount_type == 1) {
            everyDiscountData.cate_offer = "1";
            everyDiscountData.cate_offer_value = [];
            this.type_discount_list.forEach((item) => {
              var i = {
                cate: item.id,
                discount_status: item.type == 0 ? "1" : "0",
                discount:
                  item.type == 0 ? Number(item.discount) * 10 || "100" : "",
                money_status: item.type == 1 ? "1" : "0",
                money: item.type == 1 ? item.money : "",
                dec_status: item.type == 2 ? "1" : "0",
                dec_money: item.type == 2 ? item.dec_money : "",
                dis_str:
                  item.type == 0
                    ? `每满${this.everyMoney}元${
                        this.type_options.find((x) => x.id == item.id).name
                      }${item.discount}折优惠`
                    : item.type == 1
                    ? `每满${this.everyMoney}元${
                        this.type_options.find((x) => x.id == item.id).name
                      }每升优惠${item.money}元`
                    : `每满${this.everyMoney}元${
                        this.type_options.find((x) => x.id == item.id).name
                      }优惠${item.dec_money}元`,
              };
              everyDiscountData.cate_offer_value.push(i);
            });
          }
          if (this.discount_type == 2) {
            everyDiscountData.goods_offer = "1";
            everyDiscountData.goods_offer_value = [];
            console.log(this.oils_discount_list);
            this.oils_discount_list.forEach((item) => {
              var g = {
                goods: item.id,
                discount_status: item.type == 0 ? "1" : "0",
                discount:
                  item.type == 0 ? Number(item.discount) * 10 || "100" : "",
                money_status: item.type == 1 ? "1" : "0",
                money: item.type == 1 ? item.money : "",
                dec_status: item.type == 2 ? "1" : "0",
                dec_money: item.type == 2 ? item.dec_money : "",
                dis_str:
                  item.type == 0
                    ? `每满${this.everyMoney}元${
                        this.oils_options.find((x) => x.id == item.id).name
                      }汽油${item.discount}折优惠`
                    : item.type == 1
                    ? `每满${this.everyMoney}元${
                        this.oils_options.find((x) => x.id == item.id).name
                      }汽油每升优惠${item.money}元`
                    : `每满${this.everyMoney}元${
                        this.oils_options.find((x) => x.id == item.id).name
                      }汽油优惠${item.dec_money}元`,
              };
              everyDiscountData.goods_offer_value.push(g);
            });
          }
          data.every_discount[this.everyMoney] = Object.assign(
            {},
            everyDiscountData
          );
          console.log(data);
        } else {
          // 无限制
          data.full_reduction = 0;
          data.every_reduction = 0;
          if (this.discount_type == 0) {
            data.unified_offer = "1";
            data.unified_offer_value = {
              discount_status: this.unified_type == 0 ? "1" : "0",
              discount:
                this.unified_type == 0
                  ? Number(this.unified_type_value.discount) * 10 || "100"
                  : "",
              money_status: this.unified_type == 1 ? "1" : "0",
              money:
                this.unified_type == 1 ? this.unified_type_value.money : "",
              dis_str:
                this.unified_type == 0
                  ? `${this.unified_type_value.discount}折优惠`
                  : `每升优惠${this.unified_type_value.money}元`,
            };
          }
          if (this.discount_type == 1) {
            data.cate_offer = "1";
            data.cate_offer_value = [];
            this.type_discount_list.forEach((item) => {
              var i = {
                cate: item.id,
                discount_status: item.type == 0 ? "1" : "0",
                discount:
                  item.type == 0 ? Number(item.discount) * 10 || "100" : "",
                money_status: item.type == 1 ? "1" : "0",
                money: item.type == 1 ? item.money : "",
                dis_str:
                  item.type == 0
                    ? `${this.type_options.find((x) => x.id == item.id).name}${
                        item.discount
                      }折优惠`
                    : `${
                        this.type_options.find((x) => x.id == item.id).name
                      }每升优惠${item.money}元`,
              };
              data.cate_offer_value.push(i);
            });
          }
          if (this.discount_type == 2) {
            data.goods_offer = "1";
            data.goods_offer_value = [];
            console.log(this.oils_discount_list);
            this.oils_discount_list.forEach((item) => {
              var g = {
                goods: item.id,
                discount_status: item.type == 0 ? "1" : "0",
                discount:
                  item.type == 0 ? Number(item.discount) * 10 || "100" : "",
                money_status: item.type == 1 ? "1" : "0",
                money: item.type == 1 ? item.money : "",
                dis_str:
                  item.type == 0
                    ? `${
                        this.oils_options.find((x) => x.id == item.id).name
                      }汽油${item.discount}折优惠`
                    : `${
                        this.oils_options.find((x) => x.id == item.id).name
                      }汽油每升优惠${item.money}元`,
              };
              data.goods_offer_value.push(g);
            });
          }
        }
      }
      // if(data.discount == undefined || data.discount == ''){
      //   data.discount == 100;
      // }else{
      //   data.discount = Number(data.discount) * 10;
      // }
      // data.discount = Number(data.discount) * 10 || '100';
      /**
       * 新增优惠时间处理
       */
      data.time_status = this.timeType;
      data.day_status = 0;
      data.month_status = 0;
      data.week_status = 0;
      data.week_unify = this.week_unify;
      if (data.time_status == 1) {
        //固定时间段
        data.start_time = this.dateValue[0];
        data.end_time = this.dateValue[1];
      }
      if (data.time_status == 2) {
        //按周期重复
        if (this.periodType == "0") {
          data.day_status = 1;
          data.day_value = {
            start_time: this.dayTimeValue[0],
            end_time: this.dayTimeValue[1],
          };
        } else if (this.periodType == "1") {
          data.month_status = 1;
          data.month_value = {
            start_time: this.monthTimeValue[0],
            end_time: this.monthTimeValue[1],
            number: this.monthDayValue.join(","),
          };
        } else if (this.periodType == "2") {
          var rule = {
            Mon: "",
            Tue: "",
            Wed: "",
            Thur: "",
            Fri: "",
            Sat: "",
            Sun: "",
          };
          this.weekDayValue.forEach((item) => {
            if (item.rule[0].stime && item.rule[0].etime) {
              var itemData = [];
              item.rule.forEach((rule) => {
                // 遍历一天的时间段
                var ruleItem = {
                  time: rule.stime + "," + rule.etime, // 时间段时间
                };
                if (this.week_unify == "0") {
                  // 每天单独设置优惠
                  data.every_reduction = 0;
                  ruleItem.full_reduction = rule.full_reduction == 1 ? 1 : 0;
                  ruleItem.every_reduction = rule.full_reduction == 2 ? 1 : 0;
                  if (rule.full_reduction == 1) {
                    // 分满减区间
                    var full_discount = {};
                    rule.discountList.forEach((fullItem) => {
                      var dItem = {};
                      console.log(fullItem);
                      if (fullItem.discount_type == 0) {
                        // 满减区间 统一优惠
                        dItem.unified_offer = "1";
                        dItem.unified_offer_value = {};
                        if (fullItem.discount.unified_offer_value.type == 0) {
                          dItem.unified_offer_value.discount_status = 1;
                          dItem.unified_offer_value.discount =
                            Number(
                              fullItem.discount.unified_offer_value.discount
                            ) * 10 || 100;
                        } else if (
                          fullItem.discount.unified_offer_value.type == 1
                        ) {
                          dItem.unified_offer_value.money_status = 1;
                          dItem.unified_offer_value.money =
                            fullItem.discount.unified_offer_value.money;
                        } else if (
                          fullItem.discount.unified_offer_value.type == 2
                        ) {
                          dItem.unified_offer_value.dec_status = 1;
                          dItem.unified_offer_value.dec_money =
                            fullItem.discount.unified_offer_value.dec_money;
                        }
                      } else if (fullItem.discount_type == 1) {
                        // 满减区间 按类别优惠
                        dItem.cate_offer = "1";
                        dItem.cate_offer_value = [];
                        fullItem.discount.cate_offer_value.forEach((cate) => {
                          var cateItem = {
                            cate: cate.id,
                          };
                          if (cate.type == 0) {
                            cateItem.discount_status = 1;
                            cateItem.discount =
                              Number(cate.discount) * 10 || "100";
                            cateItem.dis_str = `${
                              this.type_options.find((x) => x.id == cate.id)
                                .name
                            },${cate.discount}折优惠`;
                          } else if (cate.type == 1) {
                            cateItem.money_status = 1;
                            cateItem.money = cate.money;
                            cateItem.dis_str = `${
                              this.type_options.find((x) => x.id == cate.id)
                                .name
                            }每升优惠${cate.money}元`;
                          } else if (cate.type == 2) {
                            cateItem.dec_status = 1;
                            cateItem.dec_money = cate.dec_money;
                            cateItem.dis_str = `${
                              this.type_options.find((x) => x.id == cate.id)
                                .name
                            },优惠${cate.money}元`;
                          }
                          dItem.cate_offer_value.push(cateItem);
                        });
                      } else if (fullItem.discount_type == 2) {
                        // 满减区间 按油品优惠
                        dItem.goods_offer = "1";
                        dItem.goods_offer_value = [];
                        fullItem.discount.goods_offer_value.forEach((goods) => {
                          var goodItem = {
                            goods: goods.id,
                          };
                          if (goods.type == 0) {
                            goodItem.discount_status = 1;
                            goodItem.discount =
                              Number(goods.discount) * 10 || 100;
                            goodItem.dis_str = `${
                              this.oils_options.find((x) => x.id == goods.id)
                                .name
                            }汽油${goods.discount}折优惠`;
                          } else if (goods.type == 1) {
                            goodItem.money_status = 1;
                            goodItem.money = goods.money;
                            goodItem.dis_str = `${
                              this.oils_options.find((x) => x.id == goods.id)
                                .name
                            }汽油每升优惠${goods.money}元`;
                          } else if (goods.type == 2) {
                            goodItem.dec_status = 1;
                            goodItem.dec_money = goods.dec_money;
                            goodItem.dis_str = `${
                              this.oils_options.find((x) => x.id == goods.id)
                                .name
                            }汽油优惠${goods.money}元`;
                          }
                          dItem.goods_offer_value.push(goodItem);
                        });
                      }
                      console.log("4444", dItem);
                      var keyName = fullItem.num;
                      full_discount[keyName] = dItem;
                    });
                    ruleItem.full_discount = full_discount;
                  } else if (rule.full_reduction == 2) {
                    console.log("按周 每天自定义 每满减");
                    var every_discount = {};
                    if (rule.discount_type == 0) {
                      // 该时间段是统一优惠
                      every_discount.unified_offer = 1; // 统一优惠标识字段
                      if (rule.discount.unified_offer_value.type == 0) {
                        // 折扣优惠
                        every_discount.unified_offer_value = {
                          discount_status: 1,
                          discount:
                            Number(rule.discount.unified_offer_value.discount) *
                              10 || "100",
                        };
                      } else if (rule.discount.unified_offer_value.type == 1) {
                        // 每升减优惠
                        every_discount.unified_offer_value = {
                          money_status: 1,
                          money: rule.discount.unified_offer_value.money,
                        };
                      } else if (rule.discount.unified_offer_value.type == 2) {
                        // 直减优惠
                        every_discount.unified_offer_value = {
                          dec_status: 1,
                          dec_money:
                            rule.discount.unified_offer_value.dec_money,
                        };
                      }
                    } else if (rule.discount_type == 1) {
                      // 该时间段是按类别优惠
                      every_discount.cate_offer = 1; // 按类别优惠标识字段
                      every_discount.cate_offer_value = [];
                      rule.discount.cate_offer_value.forEach((cate) => {
                        // 遍历类别优惠列表
                        var cateItem = {
                          cate: cate.id,
                        };
                        if (cate.type == 0) {
                          // 折扣优惠
                          cateItem.discount_status = 1;
                          cateItem.discount =
                            Number(cate.discount) * 10 || "100";
                        } else if (cate.type == 1) {
                          // 每升减优惠
                          cateItem.money_status = 1;
                          cateItem.money = cate.money;
                        } else if (cate.type == 2) {
                          // 直减优惠
                          cateItem.dec_status = 1;
                          cateItem.dec_money = cate.dec_money;
                        }
                        every_discount.cate_offer_value.push(cateItem);
                      });
                    } else if (rule.discount_type == 2) {
                      // 该时间段是按油品优惠
                      every_discount.goods_offer = 1; // 按油品优惠标识字段
                      every_discount.goods_offer_value = [];
                      rule.discount.goods_offer_value.forEach((goods) => {
                        // 遍历油品优惠列表
                        var goodsItem = {
                          goods: goods.id,
                        };
                        if (goods.type == 0) {
                          // 折扣优惠
                          goodsItem.discount_status = 1;
                          goodsItem.discount =
                            Number(goods.discount) * 10 || "100";
                        } else if (goods.type == 1) {
                          // 每升减优惠
                          goodsItem.money_status = 1;
                          goodsItem.money = goods.money;
                        } else if (goods.type == 2) {
                          // 直减优惠
                          goodsItem.dec_status = 1;
                          goodsItem.dec_money = goods.dec_money;
                        }
                        every_discount.goods_offer_value.push(goodsItem);
                      });
                    }
                    ruleItem.every_discount = {};
                    ruleItem.every_discount[rule.every_money] = Object.assign(
                      {},
                      every_discount
                    );
                  } else {
                    // 无限制
                    ruleItem.discount = {};
                    if (rule.discount_type == 0) {
                      // 该时间段是统一优惠
                      ruleItem.discount.unified_offer = 1; // 统一优惠标识字段
                      if (rule.discount.unified_offer_value.type == 0) {
                        // 折扣优惠
                        ruleItem.discount.unified_offer_value = {
                          discount_status: 1,
                          discount:
                            Number(rule.discount.unified_offer_value.discount) *
                              10 || "100",
                        };
                      } else {
                        // 每升减优惠
                        ruleItem.discount.unified_offer_value = {
                          money_status: 1,
                          money: rule.discount.unified_offer_value.money,
                        };
                      }
                    } else if (rule.discount_type == 1) {
                      // 该时间段是按类别优惠
                      ruleItem.discount.cate_offer = 1; // 按类别优惠标识字段
                      ruleItem.discount.cate_offer_value = [];
                      rule.discount.cate_offer_value.forEach((cate) => {
                        // 遍历类别优惠列表
                        var cateItem = {
                          cate: cate.id,
                        };
                        if (cate.type == 0) {
                          // 折扣优惠
                          cateItem.discount_status = 1;
                          cateItem.discount =
                            Number(cate.discount) * 10 || "100";
                        } else {
                          // 每升减优惠
                          cateItem.money_status = 1;
                          cateItem.money = cate.money;
                        }
                        ruleItem.discount.cate_offer_value.push(cateItem);
                      });
                    } else if (rule.discount_type == 2) {
                      // 该时间段是按油品优惠
                      ruleItem.discount.goods_offer = 1; // 按油品优惠标识字段
                      ruleItem.discount.goods_offer_value = [];
                      rule.discount.goods_offer_value.forEach((goods) => {
                        // 遍历油品优惠列表
                        var goodsItem = {
                          goods: goods.id,
                        };
                        if (goods.type == 0) {
                          // 折扣优惠
                          goodsItem.discount_status = 1;
                          goodsItem.discount =
                            Number(goods.discount) * 10 || "100";
                        } else {
                          // 每升减优惠
                          goodsItem.money_status = 1;
                          goodsItem.money = goods.money;
                        }
                        ruleItem.discount.goods_offer_value.push(goodsItem);
                      });
                    }
                    if (this.week_unify == "1") {
                      delete ruleItem.discount;
                    }
                  }
                }
                itemData.push(ruleItem);
              });
              console.log(itemData);
              if (item.value == "1") {
                rule.Mon = Object.assign([], itemData);
              } else if (item.value == "2") {
                rule.Tue = Object.assign([], itemData);
              } else if (item.value == "3") {
                rule.Wed = Object.assign([], itemData);
              } else if (item.value == "4") {
                rule.Thur = Object.assign([], itemData);
              } else if (item.value == "5") {
                rule.Fri = Object.assign([], itemData);
              } else if (item.value == "6") {
                rule.Sat = Object.assign([], itemData);
              } else if (item.value == "7") {
                rule.Sun = Object.assign([], itemData);
              }
            }
          });
          data.week_status = 1;
          data.week_value = {
            week: {
              Mon: rule.Mon == "" ? "0" : "1",
              Tue: rule.Tue == "" ? "0" : "1",
              Wed: rule.Wed == "" ? "0" : "1",
              Thur: rule.Thur == "" ? "0" : "1",
              Fri: rule.Fri == "" ? "0" : "1",
              Sat: rule.Sat == "" ? "0" : "1",
              Sun: rule.Sun == "" ? "0" : "1",
            },
            rule: rule,
          };
        }
      }
      console.log("表单上传数据", data);
      // return false;
      if (this.IsShow == 0) {
        if (this.if_add) {
          if (this.listLength == 0 && data.is_default == 0) {
            this.$message("第一张会员卡必须设为默认！");
          } else {
            addLevel(data).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          }
        } else {
          editLevel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.goback();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.IsShow == 1) {
        let data2 = {
          app_id: this.app_id,
          is_open: this.is_open,
          discount: {
            ...data,
          },
        };
        data2.discount.week_unify = Number(data2.discount.week_unify);
        console.log("表单2", data2);
        this.$emit("setConfig", "add", data2);
        //散客设置
      } else {
        delete data.is_default;
        delete data.is_forever;
        delete data.is_pay;
        delete data.is_show;
        delete data.month_status;
        delete data.time_status;
        delete data.week_status;
        delete data.week_unify;
        delete data.day_status;
        delete data.id;
        delete data.platform_card_id;
        delete data.status;
        console.log("表单3", data);
        this.$emit("setConfig", data);
      }
    },
    goback() {
      if (this.IsShow == 2) {
        this.$router.push("/apply/newVip/13/card/activityCard/index");
        return false;
      }
      this.$router.go(-1);
    },
    // 优惠内容类型
    changeDiscountType(val) {
      console.log(val);
      if (this.discount_type == 0) {
      }
      if (this.discount_type == 1) {
        this.type_discount_list = [
          { id: "", type: 0, discount: "", money: "" },
        ];
        this.resetOptions(1);
      }
      if (this.discount_type == 2) {
        this.oils_discount_list = [
          { id: "", type: 0, discount: "", money: "" },
        ];
        this.resetOptions(2);
      }
    },
    // 增加规则
    addTypeItem(i) {
      if (i == 1) {
        this.type_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      } else {
        this.oils_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      }
    },
    // 删除规则
    delTypeItem(index, i) {
      if (i == 1) {
        this.type_discount_list.splice(index, 1);
      } else {
        this.oils_discount_list.splice(index, 1);
      }
      this.resetOptions(i);
    },
    // 按周增加规则
    addTypeItem2(idx, i, ruleIdx) {
      console.log(idx, ruleIdx);
      console.log(this.weekDayValue[idx].rule[ruleIdx]);
      if (i == 1) {
        this.weekDayValue[idx].rule[ruleIdx].discount.cate_offer_value.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      } else {
        this.weekDayValue[idx].rule[ruleIdx].discount.goods_offer_value.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      }
    },
    delTypeItem2(index, i, idx, ruleIdx) {
      if (i == 1) {
        this.weekDayValue[idx].rule[ruleIdx].discount.cate_offer_value.splice(
          index,
          1
        );
      } else {
        this.weekDayValue[idx].rule[ruleIdx].discount.goods_offer_value.splice(
          index,
          1
        );
      }
    },
    // 优惠区间增加规则
    addTypeItemD(i, idx) {
      if (i == 1) {
        this.discountList[idx].type_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      } else {
        this.discountList[idx].oils_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      }
    },
    // 优惠区间删除规则
    delTypeItemD(index, i, idx) {
      if (i == 1) {
        this.discountList[idx].type_discount_list.splice(index, 1);
      } else {
        this.discountList[idx].oils_discount_list.splice(index, 1);
      }
    },
    // 按周 优惠区间 增加规则
    addTypeItem3(idx, i, ruleIdx, dIndex) {
      console.log(idx, ruleIdx);
      console.log(this.weekDayValue[idx].rule[ruleIdx]);
      if (i == 1) {
        this.weekDayValue[idx].rule[ruleIdx].discountList[
          dIndex
        ].discount.cate_offer_value.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      } else {
        this.weekDayValue[idx].rule[ruleIdx].discountList[
          dIndex
        ].discount.goods_offer_value.push({
          id: "",
          type: 0,
          discount: "",
          money: "",
        });
      }
    },
    delTypeItem3(index, i, idx, ruleIdx, dIndex) {
      if (i == 1) {
        this.weekDayValue[idx].rule[ruleIdx].discountList[
          dIndex
        ].discount.cate_offer_value.splice(index, 1);
      } else {
        this.weekDayValue[idx].rule[ruleIdx].discountList[
          dIndex
        ].discount.goods_offer_value.splice(index, 1);
      }
    },
    //防止重复选择内容 优惠内容 类别/油品
    resetOptions(i) {
      if (i == 1) {
        this.type_options.forEach((item) => {
          item.disable = false;
        });
        this.type_discount_list.forEach((item) => {
          this.type_options.forEach((options) => {
            if (options.id == item.id) {
              options.disable = true;
            }
          });
        });
      } else {
        this.oils_options.forEach((item) => {
          item.disable = false;
        });
        this.oils_discount_list.forEach((item) => {
          this.oils_options.forEach((options) => {
            if (options.id == item.id) {
              options.disable = true;
            }
          });
        });
      }
    },
    // 优惠内容 输入框获得焦点的时候选中该选项
    inputFocus(type, item, index) {
      console.log(type, item, index);
      if (type == 0) {
        this.unified_type = item;
      } else if (type == 1) {
        this.type_discount_list[item].type = index;
      } else if (type == 2) {
        this.oils_discount_list[item].type = index;
      }
    },
    // 删除星期时间段
    delWeekItem(idx, i) {
      // this.weekDayValue.splice(this.weekDayValue.findIndex(x => x.value == id),1);
      // var index = this.weekOptions.findIndex(x => x.value == id);
      // this.weekOptions[index].selected = false;
      this.weekDayValue[idx].rule.splice(i, 1);
    },
    // 增加星期时间段
    addWeekItemTime(idx) {
      var data = {
        stime: "",
        etime: "",
        discount_type: 0,
        discount: {
          unified_offer_value: { type: 0, discount: "", money: "" },
          cate_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
          goods_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
        },
        discountList: [],
      };
      this.weekDayValue[idx].rule.push(data);
      // this.weekDayValue[idx].rule.push({stime:"",etime:"",discount:{}})
    },
    // 增加优惠满减区间
    addLimitItem() {
      var data = {
        num: "",
        discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
        type_options: [], //油品类别选项
        type_discount_list: [], //按类型优惠
        oils_options: [], //油品选项
        oils_discount_list: [], //按油品优惠
        unified_type: 0, //统一优惠方式 0:折扣 1:每升减价
        unified_offer_value: {
          //统一优惠方式
          type: 0,
          discount: "",
          money: "",
        },
      };
      this.discountList.push(data);
    },
    delLimitItem(i) {
      this.discountList.splice(i, 1);
    },
    // 按周自定义增加优惠区间
    addLimitItem2(idx, i) {
      var data = {
        num: "",
        discount_type: 0,
        discount: {
          unified_offer_value: {
            type: 0,
            discount: "",
            money: "",
          },
          cate_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
          goods_offer_value: [{ id: "", money: "", discount: "", type: 0 }],
        },
      };
      console.log("测试", this.weekDayValue);
      this.weekDayValue[idx].rule[i].discountList.push(data);
    },
    delLimitItem2(idx, i, index) {
      this.weekDayValue[idx].rule[i].discountList.splice(index, 1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.popverClass {
  height: 200px;
  overflow: auto;
}
</style>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}

.minWidth {
  min-width: 80px;
}

.buttonInput {
  width: 100px;
  padding: 0 10px;
  color: #409eff;
  height: 28px;
  line-height: 28px;
  border: 1px solid #409eff;
  border-radius: 5px;
  text-align: center;
}

.padding10 {
  padding: 0 10px;
  display: flex;
}

.margin10 {
  margin: 10px 0;
  display: flex;
}

.smallinput {
  width: 100px;
  padding: 0 10px;
}

.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;

  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: #fff;

    .input_box {
      width: 400px;
    }

    .input_box_small {
      width: 120px;
    }

    .input_box_mini {
      width: 60px;
    }

    .dblock {
      display: block;
      margin-top: 12px;
    }

    .type_item {
      display: flex;

      .type_name {
        padding-right: 10px;
        margin-top: 15px;
        margin-right: 10px;
        border-right: 1px solid #eee;
      }

      .type_del {
        margin-top: 10px;
      }
    }

    .add_button {
      margin-top: 15px;
    }

    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }

    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;

      .ml30 {
        margin-left: 30px;
      }
    }

    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
  }

  .day_time_box {
    width: 80px;
  }

  .radio_name {
    margin-right: 15px;
  }

  .week_select {
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .week_item {
    margin-left: 57px;
    margin-top: 10px;
    line-height: 20px;
    color: #333;

    span {
      margin: 0 10px;
    }

    .show_set {
      display: inline-block;
      margin-left: 20px;
      vertical-align: top;
    }

    .week_item_timeItem {
      margin-bottom: 10px;
    }

    .week_item_label {
      display: inline-block;
      width: 50px;
    }

    .input_box_mini {
      width: 200px;
    }
  }
}

.input_box_mini {
  width: 60px;
}

.input_box_short {
  width: 80px;
}

.dblock {
  display: block;
  margin-top: 12px;
}

.type_item {
  display: flex;

  .type_name {
    padding-right: 10px;
    margin-top: 15px;
    margin-right: 10px;
    border-right: 1px solid #eee;
  }

  .type_del {
    margin-top: 10px;
  }
}
</style>
